import React, { useEffect, useMemo, useState } from 'react';
import client, { apiCall } from '../api/client';
import DataTable from '../components/DataTable';
import SearchBox from '../components/SearchBox';
import Loader from '../components/Loader';

export default function ApiCredits() {
  const [data, setData] = useState({ defaultCost: 1, methods: [] });
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiCall(client.get('/method_cost/get_list'))
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (!search) return data.methods;
    return data.methods.filter((m) => m.method.toLowerCase().includes(search.toLowerCase()));
  }, [data.methods, search]);

  const columns = [
    { key: 'method', label: 'Method', render: (row) => <code>{row.method}</code> },
    { key: 'cost', label: 'Credit cost', render: (row) => row.cost.toLocaleString() },
    { key: 'description', label: 'Description', render: (row) => row.description || '—' },
  ];

  return (
    <div className="section">
      <div className="container">
        <div className="section-header">
          <h2>API Credits</h2>
          <p>
            Every JSON-RPC method has a credit cost, deducted from your plan's daily and monthly
            allowance. Methods not listed below use the default cost of{' '}
            <strong>{data.defaultCost} credit{data.defaultCost === 1 ? '' : 's'}</strong> per call.
          </p>
        </div>
        {error && <div className="form-error">{error}</div>}
        {loading ? (
          <div className="card"><Loader label="Loading method costs..." /></div>
        ) : (
          <div className="card">
            <div className="page-toolbar">
              <SearchBox
                value={search}
                onChange={setSearch}
                onClear={() => setSearch('')}
                placeholder="Search a method, e.g. eth_call"
              />
              <span className="form-hint">{filtered.length} method{filtered.length === 1 ? '' : 's'}</span>
            </div>
            <DataTable columns={columns} rows={filtered} rowKey="uniqueId" emptyMessage="No methods match your search." />
          </div>
        )}
      </div>
    </div>
  );
}
